import type * as monaco from "monaco-editor";

export const lightTheme: monaco.editor.IStandaloneThemeData = {
  base: "vs",
  inherit: true,
  rules: [
    { token: "comment", foreground: "6c757d" },
    { token: "keyword", foreground: "3B82F6" },
    { token: "string", foreground: "2563eb" },
    { token: "number", foreground: "2563eb" },
  ],
  colors: {
    "editor.background": "#ffffff",
    "editor.foreground": "#495057",
  },
};

export const darkTheme: monaco.editor.IStandaloneThemeData = {
  base: "vs-dark",
  inherit: true,
  rules: [
    { token: "comment", foreground: "94a3b8" },
    { token: "keyword", foreground: "3B82F6" },
    { token: "string", foreground: "60a5fa" },
    { token: "number", foreground: "60a5fa" },
  ],
  colors: {
    "editor.background": "#020617",
    "editor.foreground": "#ffffff",
  },
};
